export type LoginRequestProps = {
  email: string;
  password: string;
  expiresInMinutes: number;
  refreshTokenExpiresInMinutes: number;
};

export type GoogleLoginRequestProps = {
  idToken: string;
  expiresInMinutes: number;
  refreshTokenExpiresInMinutes: number;
};

export enum USER_TYPE {
  USER = 'user',
  AGENT = 'agent',
  DEVELOPER = 'developer',
}

export enum ACTIVATION_STATUS {
  REGISTERED = 'registered',
  CONFIRMED = 'confirmed',
}

export enum MOBILE_ACTIVATION_STATUS {
  NOT_CONFIRMED = 'notConfirmed',
  CONFIRMED = 'confirmed',
}

export type RegisterRequestProps = {
  email: string;
  firstName?: string;
  lastName?: string;
  propertiesManaged?: string;
  userType?: USER_TYPE;
  profileImageURL?: string;
  activationStatus?: ACTIVATION_STATUS;
  mobilePhoneActivationStatus?: MOBILE_ACTIVATION_STATUS;
  password: string;
  confirmPassword?: string;
  mobileNumber?: string;
  optForMarketingMaterial?: boolean;
  captchaResponse?: string;
};

export type RegisterResponseProps = {
  email: string;
  firstName: string;
  lastName: string;
  propertiesManaged: string;
  contactDetailsPrivate: boolean;
  mobileNumber: string;
  userType: USER_TYPE;
  profileImageURL: string;
  activationStatus: ACTIVATION_STATUS;
  mobilePhoneActivationStatus: MOBILE_ACTIVATION_STATUS;
  notifyToShareOnSocialMedia?: boolean;
  id: string;
  createdAt: Date;
  signupDate: Date;
};

export type RefreshTokenRequestProps = {
  accessToken: string;
  refreshToken: string;
  expiresInMinutes?: number;
  refreshTokenExpiresInMinutes?: number;
};
